import React, {PropTypes as T} from 'react';
import ChevronIcon from '../../common/icons/icon_chevron_right';

export default class MoreInformationButton extends React.Component {
  static propTypes = {
    text: T.string,
    onClick: T.func
  };

  render () {
    return <a
      tabIndex="0"
      role="button"
      className="more_information__button"
      data-component="modal-event-information-info-topic"
      onClick={this.props.onClick} >
      <div className="more_information__button__text">{this.props.text}</div>
      <ChevronIcon className="more_information__chevron" />
    </a>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/messages/more_information_button.js